import { Text } from '@consta/uikit/Text'
import type { TreeInputProps } from '@core/components'
import { TreeInput } from '@core/components'
import type { FC } from 'react'

import css from './TreeInputWithText.css'

type TreeInputWithTextProps = TreeInputProps & {
  text: string
}

export const TreeInputWithText: FC<TreeInputWithTextProps> = ({ text, ...treeInputProps }) => (
  <div className={css.treeInputWithText}>
    <Text view="secondary" size="xs">
      {text}
    </Text>
    <TreeInput {...treeInputProps} />
  </div>
)
